var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.722,
    height: 42.296,
    viewBox: "0 0 31.722 42.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location-pin",
    d: "M27.361,0A15.937,15.937,0,0,0,11.5,15.975c0,12.518,14.37,25.443,14.981,25.985a1.325,1.325,0,0,0,1.759,0c.612-.545,14.981-13.469,14.981-25.987A15.937,15.937,0,0,0,27.361,0Zm0,24.672a8.812,8.812,0,1,1,8.812-8.812A8.822,8.822,0,0,1,27.361,24.672Z",
    transform: "translate(-11.5)",
    fill: "#eb003d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLocation);
export default __webpack_public_path__ + "static/media/userLocation.f501db00f6a488a476a4cc9fa4b66986.svg";
export { ForwardRef as ReactComponent };